export default class Utils {
    static getImage(metal) {

        let image = ''

        switch (metal) {
            case "Oro":
                image = "./images/OroFIAP.png";
                break;
            case "Plata":
                image = "./images/PlataFIAP.png";
                break;
            case "Bronce":
                image = "./images/BronceFIAP.png";
                break;
            default:
                break;
        }

        return image;
    }

    static removeAccents(string){
        return string.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
}